module.exports = __webpack_public_path__ + "img/wl_code_2.d20ddac9.png";